import { createContext, use } from 'react';

import type { GridsterEngine } from './core/gridster-engine';

export const GridsterContext = createContext<GridsterEngine | null>(null);

export const useGridster = (): GridsterEngine => {
  const gridster = use(GridsterContext);

  if (!gridster) {
    throw new Error('Gridster components must be used within a Gridster component');
  }

  return gridster;
};
